class PrintHandler {
  constructor(config = {}) {
    const {
      lazyLoadInstance,
    } = config;

    this.lazyLoadInstance = lazyLoadInstance;
    this.printButton = document.querySelector('.js-print-call');
    this.loadAllImages = null;

    if (this.printButton) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.printButton.addEventListener('click', () => this.handlePrintCall());
  }

  handlePrintCall = async () => {
    this.loadStuff();
  }


  loadStuff = () => {

    // there's already a print request active
    if (window.printInRequest) {
      return;
    }

    //already loaded
    if (window.imagesLoadedForPrint) {
      window.print();
      return;
    }

    //in case there are no pictures to print
    let lazyCount = document.querySelectorAll('.lazy').length;
    if (!lazyCount || lazyCount == 0) {
      window.print();
      return;
    }


    //start print request
    window.printInRequest = true;

    // cursor indicator for somethings happening
    document.body.style.cursor = "progress";
    this.printButton.style.cursor = "progress";

    this.lazyLoadInstance.loadAll();

    var intervalId = setInterval(() => {
      if (this.lazyLoadInstance.toLoadCount == 0) {

        this.printButton.style.cursor = "pointer";
        document.body.style.cursor = "auto";

        window.printInRequest = false;

        clearInterval(intervalId);
        window.print();
      }
    }, 100);
  }
}

export default PrintHandler;